module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/flowers@2x_233fcb.jpg";